import Swiper from "swiper";
const state = {
  components: [],
}

const cacheState = () => {
  const sections = Array.from(document.querySelectorAll('[data-section="hub-models"]'));
  state.components = sections.reduce((components, section) => {
    const componentData = {
      id: section.dataset.overlayId,
      backgroundSlider: {el: section.querySelector('.hub-models__background')},
      mainSlider: {el: section.querySelector('.hub-models__main')},
      titlesSlider: {el: section.querySelector('.hub-models__title-list')},
      navigation: {
        prev: section.querySelector('.hub-models__navigation--prev'),
        next: section.querySelector('.hub-models__navigation--next')
      },
      totalSlides: Array.from(section.querySelectorAll('.hub-models__main-item')).length,
      nextIndex: 1,
    }
    return [...components, componentData];
  }, [])
}

const initSwiper = () => {
  state.components.forEach(component => {
    component.backgroundSlider.swiper = new Swiper(component.backgroundSlider.el, {
      loop: true,
      slidesPerView: 1,
      centeredSlides: true,
      allowTouchMove: false,
    });
    component.mainSlider.swiper = new Swiper(component.mainSlider.el, {
      loop: true,
      slidesPerView: 1,
      loopAdditionalSlides: component.totalSlides * 4,
      centeredSlides: true,
      preventInteractionOnTransition: true,
      draggable: true,
      on: {
        transitionEnd: function (swiper) {
          const mainIndex = this.realIndex;
          const backgroundIndex = component.backgroundSlider.swiper.realIndex;
          const slideDiff = mainIndex - backgroundIndex;
          const { totalSlides } = component;
          if (slideDiff === 0) return;

          const slideToBeginningFromEnd = mainIndex === 0 && backgroundIndex === totalSlides - 1;
          const slideToEndFromBeginning = mainIndex === totalSlides - 1 && backgroundIndex == 0;
          const slideNext = slideDiff == 1;
          const slidePrev = slideDiff == -1

          if (slideToBeginningFromEnd || slideNext) {
            component.backgroundSlider.swiper.slideNext(1000)
            component.titlesSlider.swiper.slideNext(1000)
          } else if (slideToEndFromBeginning || slidePrev) {
            component.backgroundSlider.swiper.slidePrev(1000)
            component.titlesSlider.swiper.slidePrev(1000)
          } else {
            component.backgroundSlider.swiper.slideTo(swiper.realIndex + 1, 1000)
            component.titlesSlider.swiper.slideTo(swiper.realIndex + 1, 1000)
          }
        },
      },
      breakpoints: {
        700: {
          slidesPerView: 3,
        },
      }
    })

    component.titlesSlider.swiper = new Swiper(component.titlesSlider.el, {
      slidesPrevView: 1,
      loop: true,
      allowTouchMove: false,
    })
  })
}

const addEventListeners = () => {
  state.components.forEach(component => {
    component.navigation.prev.addEventListener('click', onNavClick.bind(component))
    component.navigation.next.addEventListener('click', onNavClick.bind(component))
  })

  document.addEventListener('overlay:open', updateSwiperOnShow)
}

function onNavClick(e) {
  const action = e.target.closest('button')?.dataset.action;
  this.mainSlider.swiper[action](1000, false);
  this.backgroundSlider.swiper[action](1000, false);
  this.titlesSlider.swiper[action](1000, false);
} 

const updateSwiperOnShow = (e) => {
  const componentsToUpdate = state.components.filter(component => component.id === e.detail.id);

  componentsToUpdate.forEach(component => {
    component.backgroundSlider.swiper.update();
    component.mainSlider.swiper.update();
  })
}

const init = () => {
  cacheState();
  initSwiper();
  addEventListeners();
}

export default init;